import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import App from "./App.tsx";
import "./index.css";

// Inicializa Sentry antes de qualquer render
initSentry();

// O overlay HTML (#html-loading) é removido pelo TenantContext
// quando o condomínio terminar de carregar — não aqui.
createRoot(document.getElementById("root")!).render(<App />);
